export default __webpack_public_path__ + "static/media/grpc.c3a45785.svg";